import dayjs from "dayjs"

export function formatDateTime(
  time?: string | dayjs.Dayjs,
  format: string = "YYYY-MM-DD HH:mm:ss"
) {
  return time ? (dayjs.isDayjs(time) ? time : dayjs(time)).format(format) : "-"
}
